import { render, staticRenderFns } from "./WelcomeModal.vue?vue&type=template&id=06d94b0a&"
import script from "./WelcomeModal.vue?vue&type=script&lang=js&"
export * from "./WelcomeModal.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeModal.vue?vue&type=style&index=0&id=06d94b0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports